import React from "react";
import Hero from "../../components/home/Hero";
import Benefits from "../../components/home/Benefits";
import HomeProductSection from "../../components/home/HomeProductsSection";

const Home = () => {
  return (
    <>
      <Hero />
      <Benefits />
      <HomeProductSection />
    </>
  );
};

export default Home;
